import { ShieldX } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui';
import { useAuthV2Store } from './authV2Store';
import type { WebAccessDenial } from './webAccess';

export function WebAccessDenied({ denial }: { denial: WebAccessDenial }) {
  const navigate = useNavigate();
  const logout = useAuthV2Store((s) => s.logout);

  function handleSignOut() {
    logout();
    navigate('/app/login', { replace: true });
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6" data-testid="web-access-denied">
      <Card padding="none" className="max-w-md w-full p-10 text-center">
        <ShieldX className="w-12 h-12 text-gray-400 mx-auto mb-4" />
        <h1 className="text-lg font-medium text-gray-900 mb-2">{denial.title}</h1>
        <p className="text-sm text-gray-500 mb-6">{denial.message}</p>
        <Button type="button" onClick={handleSignOut} data-testid="web-access-denied-sign-out">
          Sign out
        </Button>
      </Card>
    </div>
  );
}
